import React from "react"
import { Link } from 'MWComponents';
import '../less/pbpEntity.less';
import banner_img from '../img/pbp_entity_banner_img.png'
import services_img_1 from '../img/services_img_1.png'
import services_img_2 from '../img/services_img_2.png'
import services_img_3 from '../img/services_img_3.png'
import shop_icon_1 from '../img/shop_icon_1.svg'
import shop_icon_2 from '../img/shop_icon_2.svg'
import shop_icon_4 from '../img/shop_icon_4.svg'
import shop_icon_5 from '../img/shop_icon_5.svg'
import shop_icon_7 from '../img/shop_icon_7.svg'
import shop_icon_8 from '../img/shop_icon_8.svg'
import shop_icon_9 from '../img/shop_icon_9.svg'
import shop_icon_10 from '../img/shop_icon_10.svg'
import shop_icon_12 from '../img/shop_icon_12.svg'
import shop_icon_13 from '../img/shop_icon_13.svg'
import shop_icon_14 from '../img/shop_icon_14.svg'
import shop_icon_15 from '../img/shop_icon_15.svg'
import shop_icon_16 from '../img/shop_icon_16.svg'
import calc_circle from '../img/calc_circle.svg'
import attention_img from '../img/attention_img.svg'
import usage_block_data from "../enums/pbp_usage_block_data.json";
import Banner from "../../../auxiliary-components/shared/Banner";
import UsageBlock from "../../../auxiliary-components/shared/UsageBlock";
import FilesForDownload from '../../../auxiliary-components/shared/FilesForDownload/views/file.c';
import BusinessNewOrder from '../../BusinessNewOrder';
import tg_img from '../img/tg_img.png';
import instruments_img_1 from '../img/instruments_img_1.png';
import instruments_img_2 from '../img/instruments_img_2.png';
import arrow_img_1 from '../img/arrow_img_1.png';
import arrow_img_2 from '../img/arrow_img_2.png';
import {
  allo, brend_thing_pbp,
  comfy, ctrs, epicentrk, foxtrot, jabko, moyo, pbp_api_docs,
  pbpCredit,
  rozetka, storeInUa,
  touch,
  ukrzoloto,
  yabloki,
  zolotoyvek
} from "../../../services/urls/urls";
import TextAboveFooter from "../../../auxiliary-components/shared/TextAboveFooter/views/TextAboveFooter.c";
import PbpEntityOrder from "../components/PbpEntityOrder";


export default function() {
    const page = 'pbp-entity',
        isMobile = this.isViewportMobile(),
      {isCashbackPage} = this.props,
      utmParams = this.state.utmParams,
      modal = this.state.showModal ? <BusinessNewOrder attribute={'pbp-entity'} utmParams={utmParams}  closeModal={this.toggleModal} /> : '',
      modal2 = this.state.showSecondModal ? <PbpEntityOrder attribute={'pbp-entity'} utmParams={utmParams}  closeModal={this.toggleSecondModal} /> : '',
      shops ={
        tech: [
          {title: 'PBP_ENTITY_SHOPS_ITEM_15', img: shop_icon_15, link: ctrs},
          {title: 'PBP_ENTITY_SHOPS_ITEM_12', img: shop_icon_12, link: moyo},
          {title: 'PBP_ENTITY_SHOPS_ITEM_13', img: shop_icon_13, link: foxtrot},
          {title: 'PBP_ENTITY_SHOPS_ITEM_7', img: shop_icon_7, link: touch},
          {title: 'PBP_ENTITY_SHOPS_ITEM_2', img: shop_icon_2, link: comfy},
          {title: 'PBP_ENTITY_SHOPS_ITEM_14', img: shop_icon_14, link: jabko},
          {title: 'PBP_ENTITY_SHOPS_ITEM_8', img: shop_icon_8, link: yabloki},
          {title: 'PBP_ENTITY_SHOPS_ITEM_16', img: shop_icon_16, link: storeInUa},

        ],
        loves: [
          {title: 'PBP_ENTITY_SHOPS_ITEM_5', img: shop_icon_5, link: zolotoyvek},
          {title: 'PBP_ENTITY_SHOPS_ITEM_4', img: shop_icon_4, link: ukrzoloto},
        ],
        big: [
          {title: 'PBP_ENTITY_SHOPS_ITEM_1', img: shop_icon_1, link: rozetka},
          {title: 'PBP_ENTITY_SHOPS_ITEM_10', img: shop_icon_10, link: epicentrk},
          {title: 'PBP_ENTITY_SHOPS_ITEM_9', img: shop_icon_9, link: allo},
        ]
      },
        shopsListTech = shops.tech.map(el => {
            return (
              <a key={el[0]} className='shops-block-item' href={el.link} target="_blank">
                  <img src={el.img} alt={`${el.title}_IMG`}/>
                  <div >{this.l10n(el.title)}</div>
              </a>
            )
        }),
      shopsListLoves = shops.loves.map(el => {
        return (
          <a key={el[0]} className='shops-block-item' href={el.link} target="_blank">
            <img src={el.img} alt={`${el.title}_IMG`}/>
            <div >{this.l10n(el.title)}</div>
          </a>
        )
      }),
      shopsListBig = shops.big.map(el => {
        return (
          <a key={el[0]} className='shops-block-item' href={el.link} target="_blank">
            <img src={el.img} alt={`${el.title}_IMG`}/>
            <div >{this.l10n(el.title)}</div>
          </a>
        )
      }),
        calculator =
          (<div className="calculator">
              <div className="calculator-title">{this.l10n('PBP_ENTITY_CALC_TITLE')}</div>
              <div className="calculator-body">
                  <div className="calculator-body-payments">
                      <div className="calculator-body-payments-header">
                          <div>{this.l10n('PBP_ENTITY_CALC_HEADER_1')}</div>
                          <div>{this.l10n('PBP_ENTITY_CALC_HEADER_2')}</div>
                      </div>
                      <div className="calculator-body-payments-right-side">
                          <div className="calculator-body-payments-body-wrapper" ref={this.calcBodyWrapper}>
                              <div className="calculator-body-payments-body" ref={this.calcBody}
                                   style={{ transform: `translate(-${this.state.calcTranslate}%)` }}>
                                  {Object.entries(this.rates).map(el => {
                                      return (
                                        <div key={el[0]} className="calculator-body-payments-body-count">
                                            <div>{el[0]}</div>
                                            <div>{el[1]}</div>
                                        </div>
                                      );
                                  })}
                              </div>
                          </div>
                      </div>
                  </div>
                  <div className="calc-bottom">
                      <div className="calc-input">
                          <input value={this.state.calcInputValue}
                                 onChange={(e) => this.onCalcChange(e.target.value)}
                                 type="range" />
                          <div className="calc-input-body"
                               style={{ background: `linear-gradient(90deg, #00D352 ${this.state.calcInputValue}%, rgba(13, 12, 34, 0.1) ${this.state.calcInputValue}%)` }}>
                              <img className="calc-input-circle" src={calc_circle} alt={calc_circle}
                                   style={{ left: `calc(${this.state.calcInputValue}% - 8px)` }}></img>
                          </div>
                      </div>
                      <div className="calc-hint"
                           dangerouslySetInnerHTML={{ __html: this.l10n('PBP_ENTITY_CALC_HINT') }} />
                      <div className="btn-wrapper-item">
                        <button className="btn-black"
                                onClick={this.toggleSecondModal}>
                          {this.l10n('PBP_ENTITY_BANNER_BTN_2')}
                        </button>
                      </div>
                  </div>
              </div>
          </div>)
    return (
      <div className="business-pbp-entity-page-container">
          <Banner
            img={banner_img}
            text={isCashbackPage ? '' : 'PBP_ENTITY_BANNER_DESC'}
            textMob={isCashbackPage ? '' : 'PBP_ENTITY_BANNER_DESC_MOB'}
            title={isCashbackPage ? 'PBP_ENTITY_BANNER_TITLE_CASHBACK' : 'PBP_ENTITY_BANNER_TITLE'}
            page={page + isCashbackPage ? 'cashback' : ''}
            isMobile={isMobile}
          >
              <div className={`btn-wrapper ${isCashbackPage ? 'cashback' : ''}`}>
                  <div className="btn-wrapper-item">
                    <button className="btn-black"
                            onClick={this.toggleSecondModal}>
                      {this.l10n('PBP_ENTITY_BANNER_BTN_2')}
                    </button>
                  </div>
              </div>
          </Banner>
          <div className="business-pbp-entity-content-wrapper">
              <div className="content">
                <div className='join-partners'>
                  <div className='text-part'>
                    <div className='text-part-title' dangerouslySetInnerHTML={{__html: this.l10n('PBP_ENTITY_PARTNERS_TEXT_1')}}></div>
                    <div className='text-part-attention'>
                      <img src={attention_img} alt="attention_img" />
                      <div className='text-part-attention-title' dangerouslySetInnerHTML={{__html: this.l10n('PBP_ENTITY_PARTNERS_TEXT_2')}}></div>
                    </div>
                    <a href={'/credit/pbp'} target='_self' className='text-part-text' dangerouslySetInnerHTML={{__html: this.l10n('PBP_ENTITY_PARTNERS_TEXT_4')}}></a>
                  </div>
                  <div className='shops-part'>
                    <div className='shops-part-title' dangerouslySetInnerHTML={{__html: this.l10n('PBP_ENTITY_PARTNERS_TEXT_5')}}></div>
                    <div className='shops-block'>
                      {shopsListTech}
                    </div>
                  </div>
                  <div className='shops-part'>
                    <div className='shops-part-title' dangerouslySetInnerHTML={{__html: this.l10n('PBP_ENTITY_PARTNERS_TEXT_6')}}></div>
                    <div className='shops-block'>
                      {shopsListLoves}
                    </div>
                    <div className='shops-part-title' dangerouslySetInnerHTML={{__html: this.l10n('PBP_ENTITY_PARTNERS_TEXT_7')}}></div>
                    <div className='shops-block'>
                      {shopsListBig}
                    </div>
                  </div>
                </div>
                <UsageBlock isMobile={isMobile} page={'eca'} data={usage_block_data}></UsageBlock>
                { isCashbackPage ? '' :

                  <div className="road-map">
                  <div className="road-map-item">
                    <div className="road-map-item-title"
                         dangerouslySetInnerHTML={{ __html: this.l10n("PBP_ENTITY_ROADMAP_TEXT_1") }}></div>
                  </div>
                  <div className="road-map-item">
                    <div className="road-map-item-title"
                         dangerouslySetInnerHTML={{ __html: this.l10n("PBP_ENTITY_ROADMAP_TEXT_2") }}></div>
                    <div className="road-map-item-text"
                         dangerouslySetInnerHTML={{ __html: this.l10n("PBP_ENTITY_ROADMAP_TEXT_3") }}></div>
                  </div>
                  <div className="road-map-item blue">
                    <div className="road-map-item-title"
                         dangerouslySetInnerHTML={{ __html: this.l10n("PBP_ENTITY_ROADMAP_TEXT_4") }}></div>
                    <div className="road-map-item-text"
                         dangerouslySetInnerHTML={{ __html: this.l10n("PBP_ENTITY_ROADMAP_TEXT_5") }}></div>
                  </div>
                  <div className="road-map-item">
                    <div className="road-map-item-title"
                         dangerouslySetInnerHTML={{ __html: this.l10n("PBP_ENTITY_ROADMAP_TEXT_6") }}></div>
                    <div className="road-map-item-text"
                         dangerouslySetInnerHTML={{ __html: this.l10n("PBP_ENTITY_ROADMAP_TEXT_7") }}></div>
                  </div>
                  <div className="road-map-item">
                    <div className="road-map-item-title"
                         dangerouslySetInnerHTML={{ __html: this.l10n("PBP_ENTITY_ROADMAP_TEXT_8") }}></div>
                    <div className="road-map-item-text"
                         dangerouslySetInnerHTML={{ __html: this.l10n("PBP_ENTITY_ROADMAP_TEXT_9") }}></div>
                  </div>
                </div>}
                    <div className="service-block">
                        <div className='service-block-title'>{this.l10n('PBP_SERVICES_TITLE')}</div>
                        <div className="service-block-list">
                            <div className='service-block-item'>
                                <div className='service-block-item-title'>
                                    <div>{this.l10n('PBP_SERVICES_ITEM_1_TITLE')}</div>
                                    <img src={services_img_1}></img>
                                </div>
                                <div className='service-block-item-text' dangerouslySetInnerHTML={{__html: this.l10n('PBP_SERVICES_ITEM_1_TEXT')}}/>
                            </div>
                            <div className='service-block-item'>
                                <div className='service-block-item-title'>
                                    <div>{this.l10n('PBP_SERVICES_ITEM_2_TITLE')}</div>
                                    <img src={services_img_2}></img>
                                </div>
                                <div className='service-block-item-text' dangerouslySetInnerHTML={{__html: this.l10n('PBP_SERVICES_ITEM_2_TEXT')}}/>
                            </div>
                            <div className='service-block-item'>
                                <div className='service-block-item-title'>
                                    <div>{this.l10n('PBP_SERVICES_ITEM_3_TITLE')}</div>
                                    <img src={services_img_3}></img>
                                </div>
                                <div className='service-block-item-text' dangerouslySetInnerHTML={{__html: this.l10n('PBP_SERVICES_ITEM_3_TEXT')}}/>
                            </div>
                        </div>
                    </div>
                <div className='instruments-block-title' dangerouslySetInnerHTML={{__html: this.l10n('PBP_ENTITY_INSTRUMENTS_TITLE')}}></div>
                <div className='instruments-block'>
                  <a href={brend_thing_pbp} target='_blank' className='left-side'>
                    <div className='title' dangerouslySetInnerHTML={{__html: this.l10n('PBP_ENTITY_INSTRUMENTS_TEXT_1')}}/>
                    <img className='instrument-img' src={instruments_img_1} alt="instruments_img" />
                    <img className='instrument-arrow' src={arrow_img_1} alt="arrow_img_1" />
                  </a>
                  <a href={pbp_api_docs} target='_blank' className='right-side'>
                    <div className='title' dangerouslySetInnerHTML={{__html: this.l10n('PBP_ENTITY_INSTRUMENTS_TEXT_2')}}/>
                    <img className='instrument-img' src={instruments_img_2} alt="instruments_img" />
                    <img className='instrument-arrow' src={arrow_img_2} alt="arrow_img" />
                  </a>
                </div>
                    {isCashbackPage ? '' : calculator}
                    <FilesForDownload lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, "files_to_download")}/>
                </div>
            </div>
          {modal}
          {modal2}
        </div>
    )
}
